import React from 'react';
import { Link } from 'react-router-dom';
import {Tag, TrendingDown, Gift, Calendar} from 'lucide-react';

const dealCategories = [
  {
    title: 'Ticket Deals',
    slug: '/deals/tickets',
    icon: Tag,
    description: 'Compare attraction ticket prices across vendors',
    color: 'bg-[#FF6B35]',
    savings: 'Save up to 40%'
  },
  {
    title: 'Pass Comparisons',
    slug: '/deals/passes',
    icon: TrendingDown,
    description: 'City passes vs individual tickets - what saves more?',
    color: 'bg-[#4A90E2]',
    savings: 'Best value analysis'
  },
  {
    title: 'Attraction Bundles',
    slug: '/deals/bundles',
    icon: Gift,
    description: 'Combined tickets for multiple attractions',
    color: 'bg-[#F7B32B]',
    savings: 'Bundle & save'
  },
  {
    title: 'Seasonal Promotions',
    slug: '/deals/seasonal',
    icon: Calendar,
    description: 'Limited-time offers and seasonal discounts',
    color: 'bg-[#FF6B35]',
    savings: 'Time-sensitive'
  }
];

export default function Deals() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-[#FF6B35] to-[#ff8555] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Deals & Offers</h1>
          <p className="text-xl text-gray-100 max-w-3xl">
            Compare prices, find the best deals, and save on attraction tickets and travel passes
          </p>
        </div>
      </div>

      {/* Deal Categories */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {dealCategories.map((category) => {
            const Icon = category.icon;
            return (
              <Link
                key={category.slug}
                to={category.slug}
                className="group bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-1"
              >
                <div className="flex">
                  <div className={`${category.color} p-8 flex items-center justify-center`}>
                    <Icon className="w-16 h-16 text-white" />
                  </div>
                  <div className="flex-1 p-6">
                    <div className="flex items-start justify-between mb-3">
                      <h3 className="text-2xl font-bold text-[#0A2540] group-hover:text-[#FF6B35] transition-colors">
                        {category.title}
                      </h3>
                      <span className="bg-[#F7B32B] text-white text-sm font-semibold px-3 py-1 rounded-full">
                        {category.savings}
                      </span>
                    </div>
                    <p className="text-gray-600">{category.description}</p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
